const HOUR_MS = 60 * 60 * 1000;

export function formatPerformanceSupportWait(
  createdAt: string,
  respondedAt: string | null,
  now = new Date(),
): string {
  const start = new Date(createdAt).getTime();
  const end = respondedAt ? new Date(respondedAt).getTime() : now.getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end)) {
    return '0 Horas';
  }

  const totalHours = Math.max(0, Math.floor((end - start) / HOUR_MS));
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  const dayLabel = days === 1 ? 'Dia' : 'Dias';
  const hourLabel = hours === 1 ? 'Hora' : 'Horas';

  if (days > 0 && hours > 0) {
    return `${days} ${dayLabel} ${hours} ${hourLabel}`;
  }

  if (days > 0) {
    return `${days} ${dayLabel}`;
  }

  return `${hours} ${hourLabel}`;
}
